import { render, staticRenderFns } from "./WorkOtherTitlesPanel.vue?vue&type=template&id=5cdf9c2b"
import script from "./WorkOtherTitlesPanel.vue?vue&type=script&lang=js"
export * from "./WorkOtherTitlesPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkOtherTitlesPanel.vue?vue&type=style&index=0&id=5cdf9c2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports